import { useTranslation } from "react-i18next";
import { FaLock } from "react-icons/fa6";

import EmptyElement from 'src/components/emptyElement/EmptyElement';


function PermsDenied() {
    const { t } = useTranslation(['common']);

    return (
        <EmptyElement
            icon={<FaLock />}
            title={t("perms_denied.title")}
            msg={t("perms_denied.msg")}
            actionLabel={t("perms_denied.btn")}
            actionTo="/"
        />
    )
}

export default PermsDenied;
